/* eslint-disable */
import React, {Component} from 'react';
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types';
import client from '../../Services/client'
import AuthService from '../../Services/AuthService';
import { withStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import SuccessMessage from '../AlertMessages/SuccessMsg';
import { SimpleShareButtons } from "react-simple-share";
import CssBaseline from '@material-ui/core/CssBaseline';
import styles from './Styles';
import ReactMarkdown from 'react-markdown'
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Comments from "../Comments/Comments"
import { DiscussionEmbed } from 'disqus-react';


const BasicExample = () => <SimpleShareButtons />;
const OptionsExample = () => (
    <SimpleShareButtons
      url="https://github.com/swozniak/react-simple-share"
      color="#03A9F4"
      size="50px"
    />
	
  );


class SingleTutorial extends Component {

	constructor(){
		super()
		this.state = {tutorial: null}
	}

	componentDidMount() {
   	 client.getEntries({content_type: 'tutorial', 'fields.slug': this.props.match.params.slug})
      .then(response => {
        return response.items[0].fields;
      })
      .then(fields => {
        this.setState({
          tutorial: fields
        });
      })
      .catch(console.error);
  }

	render(props){
	
		const { auth } = this.state;
		const {classes} = this.props;

		let title;
		let url;
		let id;
		let description;
		let slug;
		let tutorialmedia;
		let autor;
		if (this.state.tutorial) {
		autor = this.state.autor;
		id = this.state.id
		title = this.state.tutorial.title;
      	slug = this.state.tutorial.slug;
		  description = this.state.tutorial.description;
				tutorialmedia = this.state.tutorial.tutorialmedia.fields.file.url; 
		}	
		 return(
			<div className={classes.layout}>
			 <Grid container>
              <Grid item md={8}>
				<div className={classes.imageLayout}>
					<img className={classes.img} alt="complex" src= {tutorialmedia} />
				</div>
				<div className={classes.socialShare}>
					<h5>Share with</h5>
					<SimpleShareButtons
						url = {"https://poncianovieira.com/tutorialdetails/"+ slug }
						size="50px"
					/>
				</div>
			  </Grid>
				<Container>
					<Grid item md={12}>
					<h2>{title}</h2>
					<ReactMarkdown source={description}/>
					</Grid>
					<Comments fullUrl={url} id={id} />
				</Container>
			</Grid>
			</div>
		);
	}
}

SingleTutorial.propTypes = {
	classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(SingleTutorial);






// WEBPACK FOOTER //
// ./src/components/Tutorials/SingleTutorial.js